import $ from "jquery"

class GoToTopScroll {
  constructor() {
    this.gototopbut = $("#gototop")
    this.wholedocument = $(document)
    this.gototopbut.hide()
    this.events()
  }

  events() {
    this.wholedocument.on("scroll", this.scrollscreen.bind(this))
  }

  scrollscreen() {
    if (this.wholedocument.scrollTop() > 700) {
      this.gototopbut.fadeIn("fast")
    } else {
      this.gototopbut.fadeOut("slow")
    }
  }
}

export default GoToTopScroll
